import React from "react";
import { Space } from "antd";
import { AxBanner, AxDivider } from "@dynata/axiom3";

class Banner extends React.Component {
  render() {
    return (
      <div className="section" id="banner">
        <h3>Banner</h3>
        <p>Custom axiom banner compontent.</p>

        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>

        <Space size="large" direction="vertical">
          <Space size="large" direction="vertical">
            <pre>{`<AxBanner
  size="medium"
  icon={<i className="fak fa-customer-support-ax"></i>}
  title="Ask Dynata"
  description="Let Dynata help you get started on your next project."
  link="http://dynata.com"
  target="_blank"
/>`}</pre>
          </Space>
          <div className="prop-header">
            <p className="props-title">Props</p>
          </div>

          <table className="props-table">
            <thead>
              <tr>
                <th>Property</th>
                <th>Description</th>
                <th>Type</th>
                <th>Default</th>
                <th>Version</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>size</td>
                <td>Size of the banner</td>
                <td>small | medium | large</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>icon</td>
                <td>Banner icon</td>
                <td>reactNode</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>title</td>
                <td>Title text</td>
                <td>reactNode</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>description</td>
                <td>Description text, renders below the title.</td>
                <td>reactNode</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>link</td>
                <td>Redirect url of the banner</td>
                <td>string</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>target</td>
                <td>
                  Same as target attribute of a, works when href is specified
                </td>
                <td>string</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>...others</td>
                <td>
                  All extra props are passed down to a span element that is the
                  outermost parent of the component.
                </td>
                <td></td>
                <td>-</td>
                <td>-</td>
              </tr>
            </tbody>
          </table>

          <AxDivider orientation="left" plain>
            Size
          </AxDivider>

          <Space size="large" direction="vertical">
            <pre>{`
<AxBanner
  size="small"
  icon={<i className="fak fa-customer-support-ax"></i>}
  title={
    <span>
      Ask
      <br />
      Dynata
    </span>
  }
  description="Let Dynata help you get started on your next project."
  link="http://dynata.com"
  target="_blank"
/>

<AxBanner
  size="medium"
  icon={<i className="fak fa-customer-support-ax"></i>}
  title="Ask Dynata"
  description="Let Dynata help you get started on your next project."
  link="http://dynata.com"
  target="_blank"
/>

<AxBanner
  size="large"
  icon={<i className="fa-regular fa-person-chalkboard"></i>}
  title="Book a training session"
  description="Let Dynata help you get started on your next project."
  link="http://dynata.com"
  target="_blank"
/>`}</pre>
            <Space direction="vertical" size="large">
              <AxBanner
                size="small"
                icon={<i className="fak fa-customer-support-ax"></i>}
                title={
                  <span>
                    Ask
                    <br />
                    Dynata
                  </span>
                }
                description="Let Dynata help you get started"
                link="http://dynata.com"
                target="_blank"
              />

              <AxBanner
                size="medium"
                icon={<i className="fak fa-customer-support-ax"></i>}
                title="Ask Dynata"
                description="Let Dynata help you get started on your next project."
                link="http://dynata.com"
                target="_blank"
              />

              <AxBanner
                size="large"
                icon={<i className="fa-regular fa-person-chalkboard"></i>}
                title="Book a training session"
                description="Let Dynata help you get started on your next project."
                link="http://dynata.com"
                target="_blank"
              />
            </Space>
          </Space>
        </Space>
      </div>
    );
  }
}
export default Banner;
